import { render, staticRenderFns } from "./SectionReroderModal.vue?vue&type=template&id=207d2c21&"
import script from "./SectionReroderModal.vue?vue&type=script&lang=js&"
export * from "./SectionReroderModal.vue?vue&type=script&lang=js&"
import style0 from "./SectionReroderModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports